const MODELS = {
  VITARA: 'VITARA',
  SX4: 'SX4',
  JIMNY: 'JIMNY',
};

const formatModel = (model: string) => {
  const parseModel = model.toUpperCase();
  if (parseModel.includes(MODELS.VITARA)) {
    return MODELS.VITARA
  } else if (parseModel.includes(MODELS.SX4)) {
    return MODELS.SX4;
  } else if (parseModel.includes(MODELS.JIMNY)) {
    return MODELS.JIMNY;
  }
  return parseModel;
};

export default formatModel;